import React, { useState } from 'react'
import { Input, Form, Button, Modal } from 'antd'
import { withDomains, RESTExecutor } from '../../lib/domain'

const RefillForm = (props) => {
    const [formData, setFormData] = useState(props.refill_data)
console.log({props});
    const send_refill = RESTExecutor.post().config({
        label: "refill_table_list"
    }).connect(props.domains.activity)
    console.log({formData})

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

 

    const handleOk = () => {
        send_refill.forId(props.refill_data.id).execute(formData)
        props.loader(true);
        setTimeout(() => {
            props.refill.execute()
        }, 1000);
        props.setVisible(false);
    }

    const handleCancel = () => {
        props.setVisible(false);
    }

    return (
            <div>
            <Modal
                title={""}
                closable={false}
                style={{ top: "20px" }}
                visible={props.visible}
                destroyOnClose
                onOk={handleOk}
                okText={"Submit"}
                onCancel={handleCancel}
            
            >
                <Form>
                    <Form.Item label="Terminal ID">
                        <Input value={formData.ej_source_id} disabled />
                    </Form.Item>
                    <Form.Item label="Refill Date">
                        <Input value={formData.ej_date} disabled />
                    </Form.Item>
                    <Form.Item label="EJ ID">
                        <Input value={formData.ej_id} disabled />
                    </Form.Item>
                    <Form.Item label="EJ Balance">
                        <Input name="ej_cb" type='number' inputMode='numeric' value={formData.ej_cb} onChange={handleChange} />
                    </Form.Item>
                    <Form.Item label="EJ Refill Amount">
                        <Input name="ej_refill" type='number' inputMode='numeric' value={formData.ej_refill} onChange={handleChange} />
                    </Form.Item>
                    <Form.Item label="Ledger Date">
                        <Input value={formData.ledger_date} disabled />
                    </Form.Item>
                    <Form.Item label="Ledger ID">
                        <Input value={formData.ledger_id} disabled />
                    </Form.Item>
                    <Form.Item label="Ledger Balance">
                        <Input name="ledger_cb" type='number' inputMode='numeric' value={formData.ledger_cb} onChange={handleChange} />
                    </Form.Item>
                    <Form.Item label="Ledger Refill Amount">
                        <Input name="ledger_refill" type='number' inputMode='numeric' value={formData.ledger_refill} onChange={handleChange} />
                    </Form.Item>
                    <Form.Item label="Trace No">
                        <Input value={formData.trace_no} disabled />
                    </Form.Item>
                </Form>
            </Modal>
            </div>
    )
}

export default withDomains(RefillForm, "activity");
